module.exports = __webpack_public_path__ + "img/invoice (4).2892db0d.svg";